import { useHead } from '@unhead/react';
import { useTranslation } from 'translations/hooks';

import { MobileSingleCardPageWithFilterLayout } from 'business/layout/single-card-page-with-filter-card/mobile';
import { TableParamsProvider } from 'business/providers/table-params';
import { DEFAULT_PAGE_SIZE } from 'business/quality-control/constants';
import { DefectReportTable } from 'business/quality-control/pages/defect-report-history/components/defect-report-table';
import { DefectReportFilters } from 'business/quality-control/pages/defect-report-history/components/filters';
import {
  defaultFilters,
  DefectReportHistoryFiltersProvider,
} from 'business/quality-control/pages/defect-report-history/providers/filters';
import { useFilterData } from 'technical/filter-data';

import { ORDER_FIELD, ORDER_TYPE } from '..';

export interface DefectReportHistoryFilterData {
  selectedDefectReports?: number;
}

export function MobileDefectReportHistoryPage() {
  const { t } = useTranslation();

  const { filterData, setFilterData } =
    useFilterData<DefectReportHistoryFilterData>();

  useHead({
    title: t('user.menu.sections.qualityControl.defectReportHistory.title'),
  });

  return (
    <TableParamsProvider
      defaultPageSize={DEFAULT_PAGE_SIZE}
      defaultSortField={ORDER_FIELD}
      defaultSortOrder={ORDER_TYPE}
    >
      <DefectReportHistoryFiltersProvider initialFilters={defaultFilters}>
        <MobileSingleCardPageWithFilterLayout
          title={t(
            'user.menu.sections.qualityControl.defectReportHistory.title',
          )}
          filters={<DefectReportFilters filterData={filterData} />}
        >
          <DefectReportTable setFilterData={setFilterData} mobile />
        </MobileSingleCardPageWithFilterLayout>
      </DefectReportHistoryFiltersProvider>
    </TableParamsProvider>
  );
}
